<template>
  <div class="main" @click="pageClick">
    <div v-if="loading" class="loading-overlay">
      <div class="loading-gif"></div>
    </div>
    <div class="wrapper">
      <div class="navigation">
        <router-link to="/home"><img :src="icBack" /></router-link>
        <span>Débito Veicular</span>
        <router-link to="/home"><img :src="icClose" /></router-link>
      </div>
      <div class="content">
        <p>Parcele aqui seus débitos veiculares em até 18x!</p>
        <div class="input-container-renavam">
          <input
            type="text"
            placeholder="Digite o Renavam"
            v-model="licensePlate"
            @click="toggleKeyboard"
            :class="{ disabled: isInputDisabled }"
          />
          <select v-model="estado" class="select-estado">
            <option value="" disabled>Selecione o estado</option>
            <option value="MG">Minas Gerais</option>
            <option value="SP">São Paulo</option>
          </select>
        </div>

        <div class="error" v-if="!success">
          {{ mensagemErro }}
        </div>

        <virtual-keyboard
          v-if="isKeyboardOpen"
          @key-click="handleKeyClick"
          @close-keyboard="closeKeyboard"
          @delete-click="handleDeleteClick"
        ></virtual-keyboard>

        <a @click="avancar()">
          <img
            :src="next"
            class="nextStep"
            :class="{ disabled: !isFormValid }"
          />
        </a>
      </div>
      <FooterGlobal></FooterGlobal>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import icBack from '@/assets/svg/ic-back.svg'
import icClose from '@/assets/svg/ic-close.svg'
import icNext from '@/assets/svg/ic-next.svg'
import FooterGlobal from '@/components/Footer.vue'
import VirtualKeyboard from '@/components/VirtualKeyboard.vue'
import axios from 'axios'
import { timerToReturnToHome } from '@/helper/timer'

export default defineComponent({
  name: 'DebitoPage',
  components: {
    FooterGlobal,
    VirtualKeyboard,
  },
  data() {
    timerToReturnToHome(40000)
    return {
      icBack: icBack,
      icClose: icClose,
      next: icNext,
      licensePlate: '',
      isKeyboardOpen: false,
      isInputDisabled: false,
      Renavam: '',
      veiculo: {
        uf: '',
      },
      loading: false,
      estado: '',
      codParceiro: 1,
      taxas: null,
      success: true,
      mensagemErro: 'Erro na busca. Cheque se o Renavam está correto e tente novamente.',
    }
  },
  computed: {
    isFormValid() {
      return this.licensePlate.length === 11 && this.estado !== ''
    },
  },
  methods: {
    handleKeyClick(key) {
      if (key === 'backspace') {
        this.licensePlate = this.licensePlate.slice(0, -1)
      } else {
        this.licensePlate += key
      }
      this.licensePlate = this.licensePlate.trim()
    },
    handleDeleteClick() {
      if (this.licensePlate.length > 0) {
        this.licensePlate = this.licensePlate.slice(0, -1)
      }
    },
    toggleKeyboard() {
      this.isKeyboardOpen = !this.isKeyboardOpen
      this.isInputDisabled = this.isKeyboardOpen
    },
    closeKeyboard() {
      this.isKeyboardOpen = false
      this.isInputDisabled = false
    },

    async avancar() {
      this.licensePlate = this.licensePlate.trim()
      this.loading = true
      this.success = true
      this.mensagemErro =
        'Erro na busca. Cheque se o Renavam está correto e tente novamente.'

      try {
        await this.consultarRenavam()
        sessionStorage.setItem('renavamDigitado', this.licensePlate)
      } catch (error) {
        console.error('Erro ao tentar avançar:', error)
        this.success = false
      } finally {
        this.loading = false
      }
    },

    async consultarRenavam() {
      const url = process.env.VUE_APP_API_URL
      const username = process.env.VUE_APP_IPAG_API_USER
      const password = process.env.VUE_APP_IPAG_API_PASSWORD
      const basicAuth = btoa(`${username}:${password}`)

      const body = {
        estado: this.estado,
        renavam: this.licensePlate,
      }

      try {
        const response = await axios.post(
          `${url}/totem/debitoVeicularConsulta.php`,
          body,
          {
            headers: {
              Authorization: `Basic ${basicAuth}`,
              'Content-Type': 'application/json',
            },
          },
        )

        if (response.data?.status === true) {
          this.success = true
          sessionStorage.setItem(
            'dadosConsultaRenavam',
            JSON.stringify(response.data),
          )
          this.$router.push('/debito/selecao-debito-veicular')
          return
        }

        // status false com HTTP 200
        this.tratarErroApi(response.data)
        throw new Error('Consulta retornou status false')
      } catch (error) {
        if (error.response?.data) {
          this.tratarErroApi(error.response.data)
        } else if (!this.mensagemErro || this.mensagemErro.includes('Erro na busca')) {
          // só sobrescreve se ainda estiver a mensagem padrão
          this.mensagemErro =
            'Erro na busca. Cheque se o Renavam está correto e tente novamente.'
        }
        this.success = false
        throw error
      }
    },

    tratarErroApi(data) {
      console.log('Resposta de erro da API:', data) // para debug

      const erros =
        data?.dados?.dados?._errors ||
        data?.dados?._errors ||
        []

      const primeiroErro = erros[0]
      const codigo = String(primeiroErro?._code || '')
      const mensagemApi = (primeiroErro?._message || '').toLowerCase()

      if (
        codigo === '60166' ||
        mensagemApi.includes('código identificador inexistente') ||
        mensagemApi.includes('identificador inexistente')
      ) {
        this.mensagemErro =
          'Código do veículo não encontrado. Verifique o Renavam e tente novamente.'
        return
      }

      if (
        codigo === '60050' ||
        mensagemApi.includes('não existem débitos')
      ) {
        this.mensagemErro = 'Não existem débitos para o veículo informado.'
        return
      }

      this.mensagemErro =
        primeiroErro?._message ||
        data?.motivoCritica ||
        'Erro na busca. Cheque se o Renavam está correto e tente novamente.'
    },
  },
})
</script>